import { Button, theme } from 'antd'
import { Avatar } from 'components/avatar/avatar'
import { getCustomerName, getShopId, setCacheManually, useWindowDimensions } from 'utils'
import { HorizontalContainer } from 'components/styled'
import { Customer } from 'types'
import { useNavigate } from 'react-router-dom'

type Props = {
    customer: Customer
}

export const CustomerItem = ({ customer }: Props) => {

    //hooks:
    const { token: {
        paddingXXS,
        paddingXS,
        paddingSM,
        padding,
        borderRadius
    }} = theme.useToken()
    const navigate = useNavigate()
    const { SM } = useWindowDimensions()

    return (
        <Button
            type='text'
            style={{
                width: '100%',
                height: 'auto',
                padding: SM ? `0 ${paddingXS}px 0 0` : `0 ${padding}px 0 ${paddingSM}px`,
                borderRadius: SM ? borderRadius : 0
            }}
            onClick={() => {
                setCacheManually(['customer', customer.id, getShopId()], customer)
                navigate(`/customer/${customer.id}`)
            }}
        >

            <HorizontalContainer style={{ width: '100%' }}>

                {/* image and title */}
                <Avatar
                    name={getCustomerName(customer)}
                    image={customer.image.path}
                    description={getCustomerDescription(customer)}
                    style={{ paddingLeft: paddingXXS }}
                />

            </HorizontalContainer>

        </Button>
    )
    
}

const getCustomerDescription = (customer: Customer) => (
    customer.description || customer.email || customer.phone || null
)
